module.exports = __webpack_public_path__ + "static/img/SUP_PHOTO_AUTRE_02.7275b23.jpg";